import React from 'react'

export default function BuyMetaDetails({bhkdata,activeBhk,formatAmount,propData,activeFloorDetail}) {
  return (
      <div className="property-meta-details property-details-block">
                <div className="row make-grid-2">
                  <div className="col-lg-3 width-75 ">
                    <div className="property-meta-detail-content">
                      <div className="icon">
                        <svg
                          width="22"
                          height="20"
                          viewBox="0 0 12 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.875 17.6667L1.19802 12.8698C1.12495 12.7948 1.1821 12.6653 1.28538 12.6618C9.12386 12.3918 9.0288 1 1 1H10.75"
                            stroke="#FF3155"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M1 6.83331H10.75"
                            stroke="#FF3155"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="property-meta-detail">
                        <span className="meta-label">Price per Sq.Ft</span>
                        <span className="meta-info">
                          {/* {bhkdata.map((item) =>
                            activeBhk == item.bhkType
                              ? item.sellingAmount
                                ? formatAmount(item.sellingAmount)
                                : "-"
                              : null
                          )} */}
                          {
                            activeFloorDetail?.sellingAmount?activeFloorDetail?.sellingAmount:"-"
                          
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 width-75  ">
                    <div className="property-meta-detail-content">
                      <div className="icon">
                        {propData?.propertyDTO?.bhkType ? (
                          <svg
                            width="24"
                            height="20"
                            viewBox="0 0 24 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.2957 18.5278V16.8611M4.02295 18.5278V16.8611"
                              stroke="#FF3155"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <path
                              d="M0.75 12.9722C0.75 11.9368 0.75 11.4191 0.91608 11.0107C1.13752 10.4662 1.56227 10.0336 2.09687 9.80803C2.49783 9.63892 3.00613 9.63892 4.02273 9.63892H19.2955C20.3121 9.63892 20.8203 9.63892 21.2213 9.80803C21.7559 10.0336 22.1807 10.4662 22.4021 11.0107C22.5682 11.4191 22.5682 11.9368 22.5682 12.9722C22.5682 14.0077 22.5682 14.5254 22.4021 14.9338C22.1807 15.4782 21.7559 15.9109 21.2213 16.1365C20.8203 16.3056 20.3121 16.3056 19.2955 16.3056H4.02273C3.00613 16.3056 2.49783 16.3056 2.09687 16.1365C1.56227 15.9109 1.13752 15.4782 0.91608 14.9338C0.75 14.5254 0.75 14.0077 0.75 12.9722Z"
                              stroke="#FF3155"
                              stroke-width="1.5"
                            />
                            <path
                              d="M21.4772 9.63889C21.4772 5.44862 21.4772 3.3535 20.1991 2.05174C18.9211 0.75 16.8639 0.75 12.7499 0.75H10.5681C6.45401 0.75 4.39698 0.75 3.1189 2.05174C1.84082 3.3535 1.84082 5.44862 1.84082 9.63889"
                              stroke="#FF3155"
                              stroke-width="1.5"
                            />
                            <path
                              d="M18.7502 9.63888V7.97222C18.7502 5.87708 18.7502 4.82952 18.1111 4.17865C17.4721 3.52777 16.4436 3.52777 14.3865 3.52777H8.932C6.87496 3.52777 5.84644 3.52777 5.2074 4.17865C4.56836 4.82952 4.56836 5.87708 4.56836 7.97222V9.63888"
                              stroke="#FF3155"
                              stroke-width="1.5"
                            />
                            <path
                              d="M11.6592 4.08331V9.63887"
                              stroke="#FF3155"
                              stroke-width="1.5"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            fill="none"
                          >
                            <rect
                              x="3"
                              y="5"
                              width="18"
                              height="14"
                              stroke="#ff3155"
                              stroke-width="2"
                              rx="1"
                            />

                            <circle cx="3" cy="5" r="1.5" fill="#ff3155" />
                            <circle cx="21" cy="5" r="1.5" fill="#ff3155" />
                            <circle cx="21" cy="19" r="1.5" fill="#ff3155" />
                            <circle cx="3" cy="19" r="1.5" fill="#ff3155" />

                            <line
                              x1="6"
                              y1="2.5"
                              x2="18"
                              y2="2.5"
                              stroke="#ff3155"
                              stroke-width="1.5"
                            />
                            <line
                              x1="6"
                              y1="1.5"
                              x2="6"
                              y2="3.5"
                              stroke="#ff3155"
                              stroke-width="1.5"
                            />
                            <line
                              x1="18"
                              y1="1.5"
                              x2="18"
                              y2="3.5"
                              stroke="#ff3155"
                              stroke-width="1.5"
                            />

                            <line
                              x1="22.5"
                              y1="8"
                              x2="22.5"
                              y2="16"
                              stroke="#ff3155"
                              stroke-width="1.5"
                            />
                            <line
                              x1="21.5"
                              y1="8"
                              x2="23.5"
                              y2="8"
                              stroke="#ff3155"
                              stroke-width="1.5"
                            />
                            <line
                              x1="21.5"
                              y1="16"
                              x2="23.5"
                              y2="16"
                              stroke="#ff3155"
                              stroke-width="1.5"
                            />

                            <line
                              x1="12"
                              y1="5"
                              x2="12"
                              y2="19"
                              stroke="#ff3155"
                              stroke-width="0.8"
                              opacity="0.3"
                              stroke-dasharray="1.5 1.5"
                            />
                            <line
                              x1="3"
                              y1="12"
                              x2="21"
                              y2="12"
                              stroke="#ff3155"
                              stroke-width="0.8"
                              opacity="0.3"
                              stroke-dasharray="1.5 1.5"
                            />
                          </svg>
                        )}
                      </div>
                      <div className="property-meta-detail">
                        {propData?.propertyDTO?.bhkType ? (
                          <>
                            <span className="meta-label">Configuration</span>
                            <span className="meta-info">
                              {/* {propData?.propertyDTO?.bhkType
                                ? propData.propertyDTO.bhkType
                                : "-"} */}
                                {activeBhk ? activeBhk : "-"}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="meta-label">Property Type</span>
                            <span className="meta-info">
                              {propData?.propertyDTO?.propertyType
                                ? propData.propertyDTO.propertyType
                                : "-"}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 width-75 ">
                    <div className="property-meta-detail-content">
                      <div className="icon">
                        <svg
                          width="20"
                          height="19"
                          viewBox="0 0 20 19"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.09873 12.6418H6.9835L5.64365 16.866H1.81826C1.61865 16.866 1.45459 16.7006 1.45459 16.4993C1.45459 16.4276 1.47646 16.3587 1.51475 16.298L3.79522 12.8045C3.86357 12.7052 3.97842 12.6418 4.09873 12.6418Z"
                            fill="white"
                          />
                          <path
                            d="M6.70469 18.3357H1.81836C0.814844 18.3357 0 17.514 0 16.5021C0 16.1436 0.103906 15.7934 0.300781 15.4929L2.58125 11.9993C2.91758 11.4837 3.48633 11.1749 4.09883 11.1749H8.97695L6.70469 18.3357ZM4.09883 12.6418C3.97578 12.6418 3.86367 12.7024 3.79531 12.8072L1.51484 16.3008C1.47656 16.3614 1.45469 16.4304 1.45469 16.5021C1.45469 16.7034 1.61875 16.8688 1.81836 16.8688H5.64375L6.98359 12.6445H4.09883V12.6418Z"
                            fill="#FF3155"
                          />
                          <path
                            d="M8.07461 12.6418H11.0715L11.7633 16.8688H7.38281L8.07461 12.6418Z"
                            fill="white"
                          />
                          <path
                            d="M13.4778 18.3358H5.66846L6.83877 11.1777H12.3075L13.4778 18.3358ZM7.38291 16.8688H11.7634L11.0716 12.6418H8.07471L7.38291 16.8688Z"
                            fill="#FF3155"
                          />
                          <path
                            d="M12.5591 12.6418H15.4438C15.5669 12.6418 15.679 12.7024 15.7474 12.8072L18.0306 16.3008C18.1399 16.469 18.0935 16.6979 17.9267 16.8081C17.8665 16.8467 17.7981 16.8688 17.7271 16.8688H13.9017L12.5591 12.6418Z"
                            fill="white"
                          />
                          <path
                            d="M17.727 18.3357H12.8406L10.5684 11.1749H15.4465C16.059 11.1749 16.6277 11.4837 16.9641 11.9993L19.2445 15.4929C19.5125 15.901 19.6055 16.3918 19.507 16.8716C19.4086 17.3513 19.1324 17.7622 18.725 18.0324C18.4297 18.2309 18.0824 18.3357 17.727 18.3357ZM13.9016 16.8688H17.727C17.798 16.8688 17.8664 16.8467 17.9266 16.8081C18.0359 16.7364 18.0715 16.6317 18.0824 16.5765C18.0934 16.5214 18.1016 16.4111 18.0305 16.3008L15.75 12.81C15.6816 12.7052 15.5695 12.6445 15.4465 12.6445H12.559L13.9016 16.8688Z"
                            fill="#FF3155"
                          />
                          <path
                            d="M10.2482 14.1563C13.4857 11.3355 15.1045 8.80975 15.1045 6.58181C15.1045 3.07997 12.2963 0.733459 9.77246 0.733459C7.24863 0.733459 4.44043 3.07997 4.44043 6.58181C4.44043 8.80975 6.05918 11.3327 9.29941 14.1563C9.57012 14.3934 9.9748 14.3934 10.2482 14.1563Z"
                            fill="#FF3155"
                          />
                          <path
                            d="M9.77275 15.0662C9.43096 15.0662 9.09189 14.9476 8.82119 14.7105C5.38408 11.716 3.71338 9.05515 3.71338 6.5818C3.71338 2.6443 6.84697 0 9.77275 0C12.6985 0 15.8321 2.6443 15.8321 6.5818C15.8321 9.05515 14.1614 11.716 10.7216 14.7105C10.4536 14.9476 10.1118 15.0662 9.77275 15.0662ZM9.77275 1.46691C7.59346 1.46691 5.16807 3.56801 5.16807 6.5818C5.16807 8.57537 6.71846 10.9384 9.77275 13.602C12.8298 10.9384 14.3774 8.57537 14.3774 6.5818C14.3774 3.56801 11.9521 1.46691 9.77275 1.46691Z"
                            fill="#FF3155"
                          />
                          <path
                            d="M7.10645 6.11304C7.10645 6.82605 7.38733 7.50986 7.8873 8.01404C8.38728 8.51822 9.06539 8.80146 9.77246 8.80146C10.4795 8.80146 11.1576 8.51822 11.6576 8.01404C12.1576 7.50986 12.4385 6.82605 12.4385 6.11304C12.4385 5.40003 12.1576 4.71622 11.6576 4.21204C11.1576 3.70787 10.4795 3.42462 9.77246 3.42462C9.06539 3.42462 8.38728 3.70787 7.8873 4.21204C7.38733 4.71622 7.10645 5.40003 7.10645 6.11304Z"
                            fill="#FFEAEE"
                          />
                          <path
                            d="M9.77275 9.53491C7.90244 9.53491 6.37939 7.99907 6.37939 6.11304C6.37939 4.22701 7.90244 2.69116 9.77275 2.69116C11.6431 2.69116 13.1661 4.22425 13.1661 6.11304C13.1661 8.00182 11.6431 9.53491 9.77275 9.53491ZM9.77275 4.15532C8.70361 4.15532 7.83408 5.03215 7.83408 6.11028C7.83408 7.1884 8.70361 8.06524 9.77275 8.06524C10.8419 8.06524 11.7114 7.1884 11.7114 6.11028C11.7114 5.03215 10.8419 4.15532 9.77275 4.15532Z"
                            fill="#FF3155"
                          />
                        </svg>
                      </div>
                      <div className="property-meta-detail">
                        <span className="meta-label">Property Zone</span>
                        <span className="meta-info">
                          {propData?.propertyDTO?.type
                            ? propData.propertyDTO.type
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 width-75  ">
                    <div className="property-meta-detail-content">
                      <div className="icon">
                        {propData?.propertyDTO?.constructionStatus ? (
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.84091 18.9318C14.8409 18.9318 18.9318 14.8409 18.9318 9.84091C18.9318 4.84091 14.8409 0.75 9.84091 0.75C4.84091 0.75 0.75 4.84091 0.75 9.84091C0.75 14.8409 4.84091 18.9318 9.84091 18.9318Z"
                              stroke="#FF3155"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M5.97705 9.84094L8.54978 12.4137L13.7043 7.26825"
                              stroke="#FF3155"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 71.682 71.682"
                            fill="#ff3155"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="4.5"
                              y="4.5"
                              width="62.682"
                              height="62.682"
                              fill="none"
                              stroke="#ff3155"
                              stroke-width="7"
                              rx="6.721"
                            />

                            <path d="M60.482 0H11.202c-3.809 0-6.72 2.912-6.72 6.721V64.96c0 3.81 2.911 6.722 6.72 6.722h49.28c3.809 0 6.719-2.912 6.719-6.722V6.72C67.2 2.912 64.29 0 60.482 0zm2.24 64.959c0 1.346-.896 2.24-2.239 2.24H11.202c-1.344 0-2.239-.896-2.239-2.24V6.72c0-1.345.896-2.24 2.239-2.24h49.28c1.344 0 2.239.896 2.239 2.24v58.239z" />
                            <path d="M55.105 37.633l.448-.896c.447-.672.224-1.344-.448-1.568-.446-.225-1.345 0-1.567.447l-.447.896c-1.344-.447-2.239-.672-2.463-.225L40.546 53.76l5.822 3.359 10.079-17.471c.451-.224-.221-1.121-1.342-2.015z" />
                            <path d="M57.12 40.32l-4.929 8.736.896.447 4.929-8.736c.225-.223 0-.672-.224-.896-.002-.001-.45-.001-.672.449z" />
                            <path d="M40.77 60.48s2.017-.896 3.81-2.016l-3.81-2.24c-.224 2.016 0 4.256 0 4.256z" />
                            <rect
                              x="13.442"
                              y="17.024"
                              width="44.801"
                              height="4.48"
                            />
                            <rect
                              x="13.442"
                              y="25.985"
                              width="28.225"
                              height="4.479"
                            />
                            <rect
                              x="13.442"
                              y="34.944"
                              width="28.225"
                              height="4.48"
                            />
                            <rect
                              x="13.442"
                              y="43.905"
                              width="14.111"
                              height="4.479"
                            />
                          </svg>
                        )}
                      </div>
                      <div className="property-meta-detail">
                        {propData?.propertyDTO?.constructionStatus ? (
                          <>
                            <span className="meta-label">Status</span>
                            <span className="meta-info">
                              {propData?.propertyDTO?.constructionStatus
                                ? propData.propertyDTO.constructionStatus
                                : "-"}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="meta-label text-nowrap">
                              Authority approved
                            </span>
                            <span className="meta-info">
                              {propData?.propertyDTO?.revaApproved
                                ? "Yes"
                                : "No"}
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
   
  )
}

